import { h } from 'preact'; /** @jsx h */

import GiftForm from '../../../../forms/GiftForm';

import './SplitCTABox.scss';

const renderFromDone = id => {
    if (window.location.hash === '#' + id) {
        const elemtentWithForm = document.querySelector('#' + id);

        elemtentWithForm.scrollIntoView();
    }
};

const SplitCTABox = ({ color = 'secondary' }) => {
    return (
        <div className={`split-cta-box color-${color}`}>
            <div className="box left-box">
                <div>
                    <h2>Kjøp en gave til den som har alt, og ingen å miste.</h2>
                </div>
                <div className="btn-container">
                    <a href="/nettbutikk" target="_blank" className="btn btn-primary">
                        Gå til nettbutikken
                        <span className="material-symbols-outlined">open_in_new</span>
                    </a>
                </div>
            </div>
            <div className="divider">eller</div>
            <div className="box right-box">
                <div className="form-wrapper supportus-form-wrapper">
                    <GiftForm
                        id="gift-form-999"
                        level={2}
                        renderCb={renderFromDone}
                        titleStep1="Gi en julegave"
                        infoTxtStep1="Støtt årets juleaksjon"
                        options={[
                            {
                                value: 250,
                                label: '250'
                            },
                            {
                                value: 300,
                                label: '300'
                            },
                            {
                                value: 400,
                                label: '400'
                            },
                            {
                                value: 500,
                                label: '500'
                            }
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

export default SplitCTABox;
